// components/login-otp/validations.ts
import { z } from 'zod';

export const otpSchema = z.object({
  otp: z
    .string()
    .min(6, 'Mã OTP phải có 6 chữ số')
    .max(6, 'Mã OTP phải có 6 chữ số')
    .regex(/^\d{6}$/, 'Mã OTP chỉ được chứa số'),
});

export const phoneSchema = z.object({
  phoneNumber: z
    .string()
    .min(1, 'Vui lòng nhập số điện thoại')
    .refine((phone) => {
      const cleaned = phone.replace(/\D/g, '');
      // Accept numbers starting with '0' (10 digits) or '84' (11 digits)
      const isValid84Format = /^84\d{9}$/.test(cleaned);
      const isValid0Format = /^0\d{9}$/.test(cleaned);
      return isValid84Format || isValid0Format;
    }, 'Số điện thoại không hợp lệ')
    .transform((phone) => {
      const cleaned = phone.replace(/\D/g, '');
      if (cleaned.startsWith('0')) {
        return `84${cleaned.slice(1)}`;
      }
      return cleaned;
    }),
});

export type OTPFormData = z.infer<typeof otpSchema>;
export type PhoneFormData = z.infer<typeof phoneSchema>;
